import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';

interface DetailRowProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
}

const DetailRow: React.FC<DetailRowProps> = ({ label, value, mono }) => {
  const { colors } = useTheme();
  return (
    <div className={cn('flex items-start justify-between gap-4 py-2 border-b last:border-0', colors.borderLight ?? colors.border)}>
      <span className={cn('text-sm shrink-0', colors.textMuted)}>{label}</span>
      <span className={cn('text-sm font-medium text-right break-all', mono && 'font-mono text-xs', colors.text)}>
        {value}
      </span>
    </div>
  );
};

export default DetailRow;
